import * as React from "react";
import { action } from "mobx";
import { observer } from "mobx-react";

import { VocabularyCardInput } from "../categoryItemCards/VocabularyCardInput";
import { ExpressionCardInput } from "../categoryItemCards/ExpressionCardInput";
import CardTitleEditor from "../CardTitleEditor";
import { FolderBrowser } from "../../folderBrowser/FolderBrowser";
import { CategoryEditorDetails } from "./CategoryEditorDetails";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";

import { Folder, CategoryType } from "../../../models";

import { strings } from "../../../core/localizedStrings";
import { RootStore } from "stores";
import { Grid } from "@material-ui/core";

export interface CreateListsViewDialogsProps extends React.Props<any> {
    rootStore: RootStore;
}

@observer
export class CreateListsViewDialogs extends React.Component<CreateListsViewDialogsProps> {
    public render() {
        let { createListsStore } = this.props.rootStore;
        let { categoryItemToEdit, itemToEdit } = createListsStore;
        if (categoryItemToEdit !== undefined) {
            if (categoryItemToEdit.isVocabulary()) {
                return (
                    <Dialog
                        fullWidth={true}
                        open={categoryItemToEdit.text !== undefined || categoryItemToEdit.answer !== undefined}
                        onClose={this.onCardInputDialogClose}
                    >
                        <DialogTitle style={{ textAlign: "center" }}>{strings.enterVocabulary}</DialogTitle>
                        <Grid container justify="center">
                            <Grid item>
                                <VocabularyCardInput
                                    categoryItem={categoryItemToEdit}
                                    store={createListsStore}
                                    onEditCompleteCallback={this.onEditCardComplete}
                                />
                            </Grid>
                        </Grid>
                    </Dialog>
                );
            } else {
                console.log(categoryItemToEdit, categoryItemToEdit.type);
                let showDialog = false;
                let title = strings.enterQuestion;
                if (categoryItemToEdit.type === CategoryType.Lesson) {
                    title = strings.enterVocabAndQuestion;
                    showDialog = true;
                } else if (categoryItemToEdit.type === CategoryType.Expression) {
                    showDialog = true;
                } else if (
                    categoryItemToEdit.type === CategoryType.ExpressionTextOnly &&
                    categoryItemToEdit.question !== undefined
                ) {
                    // If expressionTextOnly, only show dialog if editing an existing expression
                    showDialog = true;
                }

                return (
                    <Dialog fullWidth={true} open={showDialog} onClose={this.onCardInputDialogClose}>
                        <DialogTitle style={{ textAlign: "center" }}>{title}</DialogTitle>
                        <ExpressionCardInput
                            categoryItem={categoryItemToEdit}
                            store={createListsStore}
                            onEditCompleteCallback={this.onEditCardComplete}
                        />
                    </Dialog>
                );
            }
        }
        if (itemToEdit !== undefined) {
            return (
                <Dialog fullWidth={true} open={itemToEdit !== undefined} onClose={this.onUploadImageEditClose}>
                    <CardTitleEditor title={itemToEdit.title} onEditCompleteCallback={this.onEditImageCardTitle} />
                </Dialog>
            );
        } else if (this.props.rootStore.createListsStore.folderToEdit !== undefined) {
            return (
                <Dialog
                    fullWidth={true}
                    open={this.props.rootStore.createListsStore.folderToEdit !== undefined}
                    onClose={this.onImageFolderEditClose}
                >
                    <CardTitleEditor
                        title={createListsStore.folderToEdit.title}
                        onEditCompleteCallback={this.onEditImageFolderTitle}
                    />
                </Dialog>
            );
        } else if (this.props.rootStore.createListsStore.itemToMove) {
            createListsStore.fetchRootFolderListForFolderBrowser(createListsStore.currentTab);
            return (
                <Dialog
                    fullWidth={true}
                    open={this.props.rootStore.createListsStore.itemToMove !== undefined}
                    onClose={this.onImageToMoveFolderBrowserClose}
                >
                    <FolderBrowser
                        titleMessage={strings.moveListTo}
                        onFolderSelected={this.onImageToMoveFolderSelected}
                        store={createListsStore}
                    />
                </Dialog>
            );
        } else if (this.props.rootStore.createListsStore.folderToMove) {
            createListsStore.fetchRootFolderListForFolderBrowser(createListsStore.currentTab);
            return (
                <Dialog
                    fullWidth={true}
                    open={this.props.rootStore.createListsStore.folderToMove !== undefined}
                    onClose={this.onFolderToMoveFolderBrowserClose}
                >
                    <FolderBrowser
                        titleMessage={strings.moveFolderTo}
                        onFolderSelected={this.onFolderToMoveFolderSelected}
                        store={createListsStore}
                    />
                </Dialog>
            );
        } else {
            return null;
        }
    }

    private onEditCardComplete = (text: string) => {
        let { createListsStore } = this.props.rootStore;
        createListsStore.removeFirstSelectedItem();

        let { currentCategory } = createListsStore;
        if (currentCategory.isImageCategory() || !text || text === "") {
            createListsStore.setShouldShowTextOnlyInput(false);
        }
    };

    private onCardInputDialogClose = () => {
        let { createListsStore } = this.props.rootStore;
        createListsStore.removeFirstSelectedItem();
        createListsStore.setShouldShowTextOnlyInput(false);
    };

    // Move
    private onImageToMoveFolderBrowserClose = () => {
        let { createListsStore } = this.props.rootStore;
        createListsStore.setItemToMove(undefined);
    };

    private onImageToMoveFolderSelected = (folder: Folder) => {
        let { createListsStore } = this.props.rootStore;
        if (createListsStore.visibleFolder.key !== folder.key) {
            createListsStore.moveItemToFolder(createListsStore.itemToMove, folder, createListsStore.currentTab);
        }
    };

    private onFolderToMoveFolderBrowserClose = () => {
        let { createListsStore } = this.props.rootStore;
        createListsStore.setFolderToMove(undefined);
    };

    private onFolderToMoveFolderSelected = (folder: Folder) => {
        let { createListsStore } = this.props.rootStore;
        if (createListsStore.visibleFolder.key !== folder.key) {
            createListsStore.moveFolderToFolder(createListsStore.folderToMove, folder, createListsStore.currentTab);
        }
    };

    // Edit Image Folder Actions
    @action
    private onImageFolderEditClose = () => {
        let { createListsStore } = this.props.rootStore;
        createListsStore.folderToEdit = undefined;
    };

    @action
    private onEditImageFolderTitle = (newTitle: string) => {
        let { createListsStore } = this.props.rootStore;
        createListsStore.folderToEdit!.title = newTitle;
        createListsStore.updateImageFolder(createListsStore.folderToEdit!);

        createListsStore.folderToEdit = undefined;
    };

    // Edit Upload Image Actions
    @action
    private onUploadImageEditClose = () => {
        let { createListsStore } = this.props.rootStore;
        createListsStore.itemToEdit = undefined;
    };

    @action
    private onEditImageCardTitle = (newTitle: string) => {
        let { createListsStore } = this.props.rootStore;

        createListsStore.itemToEdit!.title = newTitle;
        createListsStore.updateCategoryImageTitle(createListsStore.itemToEdit.key, newTitle);

        createListsStore.itemToEdit = undefined;
    };
}
